namespace TabAurous.Production {
    export interface MFGTransactionBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        BomProductId?: number;
        ProductCode?: string;
        CalcOnId?: number;
        AttributeId?: number;
        Attribute?: string;
        ItemTypeId?: number;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        FromDeptId?: number;
        ToDeptId?: number;
        FromWorkerId?: number;
        ToWorkerId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefTransBomId?: number;
        IsCustomerItem?: boolean;
        Markup?: number;
        SettingId?: number;
        SettingName?: string;
        StoneStatusId?: number;
        StoneStatusName?: string;
        Lab?: string;
        CertificateNo?: string;
        CategoryId?: number;
        ProductTypeId?: number;
        KaratId?: number;
        MetalColorId?: number;
    }

    export namespace MFGTransactionBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.MFGTransactionBOM';
        export const deletePermission = 'Production:MFGTransaction:Delete';
        export const insertPermission = 'Production:MFGTransaction:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:MFGTransaction:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            ProductCode = "ProductCode",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            ItemTypeId = "ItemTypeId",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            FromDeptId = "FromDeptId",
            ToDeptId = "ToDeptId",
            FromWorkerId = "FromWorkerId",
            ToWorkerId = "ToWorkerId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefTransBomId = "RefTransBomId",
            IsCustomerItem = "IsCustomerItem",
            Markup = "Markup",
            SettingId = "SettingId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            StoneStatusName = "StoneStatusName",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            CategoryId = "CategoryId",
            ProductTypeId = "ProductTypeId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId"
        }
    }
}
